export const complianceMealTimesConfig = [
  { id: 1, title: 'Breakfast', dbName: 'breakfast' },
  { id: 2, title: 'Snack', dbName: 'snack1' },
  { id: 3, title: 'Lunch', dbName: 'lunch' },
  { id: 4, title: 'Snack', dbName: 'snack2' },
  { id: 5, title: 'Dinner', dbName: 'dinner' },
  { id: 6, title: 'Snack', dbName: 'snack3' },
  { id: 7, title: 'Daily', dbName: 'daily' },
];
